import React from 'react'
import { EmptyContainer, Container } from './styles'
import { TimelineOncology } from '../timeline'
import { Loader, NotFound } from '~/components/shared/medicalViews'

interface IProps {
  isLoading: boolean
  hasData: boolean
}

export const OncologyMainPanel = ({ isLoading, hasData }: IProps): JSX.Element => {
  const contentTypeIsTimeline = 'timeline'

  if (isLoading) {
    return (
      <EmptyContainer>
        <Loader />
      </EmptyContainer>
    )
  }

  if (hasData && contentTypeIsTimeline) {
    return (
      <Container>
        <TimelineOncology />
      </Container>
    )
  }

  return (
    <EmptyContainer>
      <NotFound />
    </EmptyContainer>
  )
}
